import {getManagerHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode} from "../../assets/functions";
import {getAllDrivers} from "../Drivers/functions";

export const getAllDiscountCodes = async () => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'discountCodes', {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}

export const getDiscountCodeById = async (id) => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + `discountCodes/${id}`, {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}
export const getDiscountCodeByCustomerId = async (customerId) => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + `discountCodes?customerId=${customerId}`, {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}
export const getDiscountCodeAmountDescription = (discountCode) => {
    let billDescription = "" ;
    let deliveryDescription = "" ;
    let minimumBillAmountDescription = "" ;

    if (discountCode.billDiscountAmount){
        billDescription +=  discountCode.billDiscountAmount.toLocaleString() + " تومان تخفیف روی فاکتور"  ;
    }
    if (discountCode.billDiscountPercent){
        billDescription += discountCode.billDiscountPercent.toLocaleString() + " درصد تخفیف روی فاکتور"   ;
        if (discountCode.maxBillDiscount){
            billDescription +=  " تا سقف " + discountCode.maxBillDiscount.toLocaleString() + " تومان" ;
        }
    }

    if (discountCode.deliveryDiscountAmount){
        deliveryDescription +=  discountCode.deliveryDiscountAmount.toLocaleString() + " تومان تخفیف روی ارسال"  ;
    }
    if (discountCode.deliveryDiscountPercent){
        deliveryDescription += discountCode.deliveryDiscountPercent.toLocaleString() + " درصد تخفیف روی ارسال"   ;
        if (discountCode.maxDeliveryDiscount){
            deliveryDescription +=  " تا سقف " + discountCode.maxDeliveryDiscount.toLocaleString() + " تومان" ;
        }
    }

    if (discountCode.minimumBillAmount){
        minimumBillAmountDescription += "حداقل میزان خرید: "  + discountCode.minimumBillAmount.toLocaleString() + " تومان"  ;
    }

    return (
        <div className={"small"}>
            {billDescription && <p>{billDescription}</p>}
            {deliveryDescription && <p>{deliveryDescription}</p>}
            {minimumBillAmountDescription && <p>{minimumBillAmountDescription}</p>}
        </div>
    );
}

